import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import { loading } from '@/shared/utils/UIHelper'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import FormSearch from './search-form.js'

import PARepository from '@/shared/http/repositories/configurations/pa.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'
import GroupRepository from '@/shared/http/repositories/configurations/group'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import { JWTService } from '@/shared/services/jwt'

const DataSearch = {
  nome: null,
  document: null,
  numeroPA: null,
  nomeRegional: null,
  gerenteId: null,
  responsavelId: null,
  gruposResponsaveisId: null,
  utmCampaign: null,
  utmMedium: null,
  utmContent: null,
  utmTerm: null,
  utmSource: null,
  produtosId: null,
  diaAtrasoInicio: null,
  diaAtrasoFinal: null
}

export default {
  name: 'CardSearch',
  mixins: [ActionsForm],
  data () {
    return {
      data: DataSearch,
      form: FormSearch,
      roles: Roles,
      permissions: null,
      selected: 'gerente',
      employee: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      groups: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      responsible: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      groupResponsible: {
        listOptions: [],
        selected: null,
        selectedList: []
      },
      numeroPA: {
        listOptions: [],
        value: null,
        selectedList: []
      },
      nomeRegional: {
        listOptions: [],
        value: null,
        selectedList: []
      },
      showFilterSocialMedia: false,
      showFilterAssociado: false,
      showFilterInstituicao: false,
      showFilterResponsavel: false,
      showFilterCobranca: false,
      product: {
        listOptions: [],
        selected: null,
        selectedList: []
      }
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  created () {
    this.onClear()
    this.permissions = JWTService.GetRoles()
    this.onLoadGroups()
    this.onLoadEmployeesFromUser()
    // this.onLoadUser()
    this.onLoadProducts()
    this.onLoadPAs()
    this.onLoadRegionais()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
      this.onCloseFilterAccordion()
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          // if (this.permissions[i].role === role) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onClearFilters () {
      this.employee.selected = null
      this.responsible.selected = null
      this.groupResponsible.selected = null
      this.numeroPA.value = null
      this.nomeRegional.value = null
      Tools.ClearDataForms(this.form, this.data)
      this.onGetEmployeeAndResponsibleAndGroup()
      this.parentComponent.filters = null
      this.parentComponent.onReloadBoard()
    },
    onCloseFilterAccordion () {
      this.showFilterSocialMedia = false
      this.showFilterAssociado = false
      this.showFilterInstituicao = false
      this.showFilterResponsavel = false
      this.showFilterCobranca = false
    },
    onFilter () {
      // check and handle undefined or null values in this.data
      for (let key in this.form) {
        if (this.data[key] === null || this.data[key] === undefined) {
          this.data[key] = {}
        }
      }

      Tools.SetValueToSave(this.form, this.data)
      this.onGetEmployeeAndResponsibleAndGroup()

      if (this.validateFilter()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      } else {
        this.$eventHub.emit('Filter', { filters: null })
      }
    },
    validateFilter () {
      let result = false
      if (this.data) {
        this.data.numeroPA = this.data.numeroPA !== undefined ? this.data.numeroPA.toString() : null
        this.data.document = this.data.document ? this.data.document.toString().replace(/[^\d]+/g, '') : null
        this.data.diaAtrasoInicio = this.data.diaAtrasoInicio ? this.data.diaAtrasoInicio.toString() : null
        this.data.diaAtrasoFinal = this.data.diaAtrasoFinal ? this.data.diaAtrasoFinal.toString() : null
        this.data.nome = this.data.nome ? encodeURIComponent(this.data.nome) : null

        if (this.data.nome || this.data.document || this.data.numeroPA || this.data.nomeRegional || this.data.gerenteId || this.data.responsavelId || this.data.gruposResponsaveisId || this.data.produtosId || (this.data.diaAtrasoInicio && this.data.diaAtrasoFinal)) {
          result = true
        }
      }
      return result
    },
    mapSelectedValues (item) {
      if (!item) {
        return undefined
      }

      if (item.selected && item.selected.length > 0) {
        return item.selected.map(i => i.value)
      }

      if (item.value) {
        return item.value.value
      }

      return undefined
    },
    onGetEmployeeAndResponsibleAndGroup () {
      const fields = ['employee', 'responsible', 'groupResponsible', 'product', 'numeroPA', 'nomeRegional']
      const keys = ['gerenteId', 'responsavelId', 'gruposResponsaveisId', 'produtosId', 'numeroPA', 'nomeRegional']

      fields.forEach((field, index) => {
        this.data[keys[index]] = this.mapSelectedValues(this[field])
      })
    },
    onLoadEmployee () {
      loading.push()
      EmployeeRepository.GetAll()
        .then((res) => {
          this.employee.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
          this.responsible.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadGroups () {
      loading.push()
      GroupRepository.GetAllActive()
        .then((res) => {
          this.groups.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup}))
          this.groupResponsible.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup}))
          loading.pop()
        })
    },
    onLoadEmployeesFromUser () {
      loading.push()
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        this.onLoadEmployee()
      } else {
        AccountRepository.GetAllFromUser()
          .then((res) => {
            this.employee.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.pessoa.nome}))
            this.responsible.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome}))
            loading.pop()
          })
          .catch(this.onException)
      }
    },
    // onLoadUser () {
    //   loading.push()
    //   AccountRepository.GetAllKanbanUsers()
    //     .then((res) => {
    //       // this.responsible.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nomePessoa}))
    //       // loading.pop()
    //     })
    //     .catch(this.onException)
    // },
    onLoadProducts () {
      loading.push()
      ProductRepository.GetAll()
        .then((res) => {
          this.product.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nome}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.numero, 'text': x.descricao}))
          this.numeroPA.listOptions = result
        })
        .catch(this.onException)
    },
    onLoadRegionais () {
      RegionalRepository.GetAll()
        .then((response) => {
          // CURRENTLY BEEN SET VALUE=NOME UNTIL BACKEND ACCEPTS MULTIPLE
          let result = response.data.content
            .map((x) => ({'value': x.nome, 'text': x.nome}))
          this.nomeRegional.listOptions = result
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/search/search.js